var events = require('events');
var util = require('util');

util.inherits(storeBase, events.EventEmitter);

function storeBase (){
    events.EventEmitter.call(this);
}

storeBase.prototype.subscribe = function (callback){
    this.on('change', callback);
};

storeBase.prototype.unsubscribe = function (callback){
    this.removeListener('change', callback);
};

storeBase.prototype.emitChange = function (data) {
    this.emit('change', data);
};

// Removes Node.js warning about too many listeners
storeBase.prototype.setMaxListeners(0);

module.exports = storeBase;